import { create } from "zustand";
import { TQueueWorkflowStore } from "./types";

const useQueueWorkflowStore = create<TQueueWorkflowStore>((set) => ({
  setCreateViewPopupState: (createViewPopupState) =>
    set({ createViewPopupState }),
  viewName: "",
  setViewName: (viewName) => set({ viewName }),
  selectedFiltersOptions: {},
  setSelectedFiltersOptions: (selectedFiltersOptions) =>
    set({ selectedFiltersOptions }),
  clearSelectedPopupData: () => {
    set({ viewName: "", selectedFiltersOptions: {} });
  },
  setViewData: (viewData) => set({ viewData }),
  setIsViewEdited: (isViewEdited) => set({ isViewEdited }),
}));

export default useQueueWorkflowStore;
